import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import { ifAuthenticated } from "../access";

import EmailDetail from "@/pages/Pages/Email/EmailDetail.vue";
import EmailDetailInfo from "@/pages/Pages/Email/EmailDetailInfo.vue";
import EmailGroup from "@/pages/Pages/Email/EmailGroup.vue";
import EmailTemplates from "@/pages/Pages/Email/EmailTemplates.vue";
import EmailTemplate from "@/pages/Pages/Email/EmailTemplate.vue";
import EmailPartnerTariffs from "@/pages/Pages/Email/EmailPartnerTariffs.vue";
import EmailPartnerTariff from "@/pages/Pages/Email/EmailPartnerTariff.vue";
import EmailProviderTariffs from "@/pages/Pages/Email/EmailProviderTariffs.vue";
import EmailProviderTariff from "@/pages/Pages/Email/EmailProviderTariff.vue";

const emailMenu = {
  path: "/email",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/email/detail",
  name: "Email",
  children: [
    {
      path: "detail",
      name: "email_detail",
      components: { default: EmailDetail },
      meta: {
        icon: "email",
        msgKey: 'menu.item.statistics.email.detail'
      },
    },
    {
      path: "detail/:id",
      name: "email_detail_info",
      components: { default: EmailDetailInfo },
      meta: {
        icon: "email",
        parentPath: "/email/detail",
        msgKey: 'menu.item.statistics.email.detail'
      },
    },
    {
      path: "group",
      name: "email_group",
      components: { default: EmailGroup },
      meta: {
        icon: "email",
        msgKey: 'menu.item.statistics.email.group'
      }
    },
    {
      path: "partners/tariffs",
      name: "email_clients_tariff",
      components: { default: EmailPartnerTariffs },
      meta: {
        icon: "email",
        msgKey: 'menu.item.email.clients.tariff'
      }
    },
    {
      path: "partners/tariffs/new",
      name: "email_clients_tariff_new",
      components: { default: EmailPartnerTariff },
      meta: {
        icon: "email",
        parentPath: "/email/partners/tariffs",
        msgKey: 'menu.item.email.clients.tariff'
      },
    },
    {
      path: "partners/tariffs/:id",
      name: "email_clients_tariff_edit",
      components: { default: EmailPartnerTariff },
      meta: {
        icon: "email",
        parentPath: "/email/partners/tariffs",
        msgKey: 'menu.item.email.clients.tariff'
      }
    },
    {
      path: "service_providers/tariffs",
      name: "email_provider_tariff",
      components: { default: EmailProviderTariffs },
      meta: {
        icon: "email",
        msgKey: 'menu.item.email.provider.tariff'
      }
    },
    {
      path: "service_providers/tariffs/new",
      name: "email_provider_tariff_new",
      components: { default: EmailProviderTariff },
      meta: {
        icon: "email",
        parentPath: "/email/service_providers/tariffs",
        msgKey: 'menu.item.email.provider.tariff'
      },
    },
    {
      path: "service_providers/tariffs/:id",
      name: "email_provider_tariff_edit",
      components: { default: EmailProviderTariff },
      meta: {
        icon: "email",
        parentPath: "/email/service_providers/tariffs",
        msgKey: 'menu.item.email.provider.tariff'
      }
    },
    {
      path: "templates",
      name: "email_templates",
      components: { default: EmailTemplates },
      meta: {
        icon: "email",
        msgKey: 'menu.item.email.templates'
      }
    },
    {
      path: "templates/new",
      name: "email_templates_new",
      components: { default: EmailTemplate },
      meta: {
        icon: "email",
        parentPath: "/email/templates",
        msgKey: 'menu.item.email.templates'
      },
    },
    {
      path: "templates/:id",
      name: "email_templates_edit",
      components: { default: EmailTemplate },
      meta: {
        icon: "email",
        parentPath: "/email/templates",
        msgKey: 'menu.item.email.templates'
      }
    }
  ],
};

export default emailMenu;
